import EditModal from './EditModal';

export default EditModal;
